import { Charger, Location } from '../../../../stores/types';
import { FinderFilters, FinderOrigin } from '../types';
import { toFinderConnectorTypes } from './connectors';
import { isValidCoordinate } from './geo';
import { getLevelFromPowerKw } from './status';

const formatLocationAddress = (location?: Location | null) => {
  if (!location) return '';
  const street =
    location.streetAddress ||
    [location.unit, location.streetNumber, location.street].filter(Boolean).join(' ');
  return [
    street,
    location.city,
    location.stateOrRegion,
    location.zipOrPostalCode,
    location.isoCountryCode,
  ]
    .filter(Boolean)
    .join(', ');
};

export const getChargerOrigin = (charger?: Charger | null): FinderOrigin | null => {
  const location = charger?.location;
  const latitude = Number(location?.latitude);
  const longitude = Number(location?.longitude);
  if (!location || !isValidCoordinate(latitude, longitude)) return null;
  return {
    latitude,
    longitude,
    label: formatLocationAddress(location) || location.name || `${latitude}, ${longitude}`,
  };
};

/** Pre-fills the finder with this charger's connectors and charging level */
export const getChargerDefaultFilters = (charger?: Charger | null): FinderFilters => {
  const ports = charger?.ports ?? [];
  const connectorTypes = Array.from(
    new Set(ports.flatMap((port) => port.connectorTypes ?? []).flatMap(toFinderConnectorTypes)),
  );
  const maxPortKw = Math.max(0, ...ports.map((port) => port.maxWattage ?? 0));
  return {
    connectorTypes,
    level: getLevelFromPowerKw(maxPortKw || charger?.maxPowerKW),
    includeUnknownStatus: false,
    networkIds: [],
  };
};
